<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="10" md="8" xl="6" class="elevation-1 mb-5 primary white--text text-center">
            <h1 class="display-2">{{ event.name }}</h1>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" md="11" lg="10" class="elevation-2 pa-5">
            <v-row justify="space-around">
              <v-col cols="12" md="7" class="text-center text-md-left pb-0">
                <span class="headline font-weight-bold mr-5">Asistentes</span>
                <v-btn color="accent" class="black--text font-weight-bold" @click="downloadCsv(event.assistants, event.name)">
                  Reporte<v-icon right>mdi-download</v-icon>
                </v-btn>
                <!--
                <p>
                  
                  <v-icon
                    v-bind:style="getSize"
                    class="excel-icon pointer ml-3 ml-md-5"
                    @click="downloadCsv(event.assistants, event.name)"
                    large
                  >fas fa-file-excel</v-icon>
                </p>-->
              </v-col>
              <!--
              <v-col cols="11" md="3" class="pt-0">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                  class="mr-0 mr-md-5"
                ></v-text-field>
                <v-btn color="accent" class="black--text font-weight-bold">
                  <v-icon class="black--text font-weight-bold">mdi-replay</v-icon>
                </v-btn>
              </v-col>
              -->

              <v-col cols="12" md="5" class="pt-0">
                <v-row>
                  <v-col cols="10">
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                      class="mr-0 mr-md-5 pt-0"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-tooltip top max-width="350px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="accent" class="black--text font-weight-bold" @click="reloadTable()" v-on="on" fab small>
                          <v-icon class="black--text font-weight-bold">mdi-cached</v-icon>
                        </v-btn>
                      </template>
                      <span>Actualizar lista de asistentes</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-divider></v-divider>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              loading-text="Cargando datos..."
              no-data-text="No hay datos disponibles."
              no-results-text="No hay datos disponibles."
              :header-props="{
                sortByText:'Ordenar por'
              }"
              :footer-props="{
                itemsPerPageText: 'Filas por página',
                itemsPerPageAllText:'Todas',
              }"
            >
              <template v-slot:body="{items}">
                <tbody>
                  <tr
                    v-for="(item, index) in items"
                    :key="index"
                    class="text-center"
                    :class="[(item.checkedIn===true)?'attended-color':'', ($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-table-row':'' ]"
                  >
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[0].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.name}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[1].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.lastName}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[2].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.companyName}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[3].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.email}}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[4].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.productName }}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[5].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.date }}</div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[6].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >
                      <v-switch v-model="item.checkedIn" color="success" @change="checkIn(item)" class="justify-center"></v-switch>
                      </div>
                    </td>
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[7].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >
                        <v-chip
                          class="pointer"
                          color="accent"
                          dark
                          @click.native.stop="selectAttendeeTicket(item)"
                        >Enviar boleto</v-chip>
                      </div>
                    </td>
                    <!--
                    <td :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[7].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              small
                              class="mr-3"
                              @click="selectItem(item, true)"
                              v-on="on"
                            >fas fa-pencil-alt</v-icon>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon small @click="selectItem(item, false)" v-on="on">fas fa-trash</v-icon>
                          </template>
                          <span>Eliminar</span>
                        </v-tooltip>
                      </div>
                    </td>
                    -->
                  </tr>
                </tbody>
              </template>
            </v-data-table>
            <v-dialog v-model="sendTicketDialog" max-width="600px">
              <v-card v-if="sendTicketDialog">
                <v-row justify="space-between" class="mx-0 px-0">
                  <v-col cols="10" class="pb-0 ma-0">
                    <p class="title font-weight-bold text-left pl-2 ma-0"> {{($vuetify.breakpoint.xsOnly)?'Envío de Acceso':'Envío manual de Acceso / Boleto'}}</p>
                  </v-col>
                  <v-col cols="2" class="pb-0 px-0 ma-0">
                    <i class="fas fa-ticket-alt fa-2x amber--text"></i>
                  </v-col>
                </v-row>
                <v-divider class="pt-3"></v-divider>
                <v-row class="ma-0">
                  <v-col cols="12" class="px-5">
                    <p><strong>Nombre:</strong> {{sendTicketItem.name}}</p>
                    <p><strong>Apellidos:</strong> {{sendTicketItem.lastName}}</p>
                    <p><strong>Boleto:</strong> {{sendTicketItem.productName}}</p>
                    <p><strong>Fecha de compra:</strong> {{sendTicketItem.date}}</p>
                    <p><strong>Comprador:</strong> {{sendTicketItem.buyer}}</p>
                  </v-col>
                  <v-col cols="12" class="px-5 d-flex">
                    <v-text-field
                      v-model="sendTicketItem.email"
                      :rules="emailRules"
                      label="E-mail que recibirá el boleto / acceso"
                      required
                      prepend-icon="fas fa-envelope"
                    ></v-text-field>
                    <v-tooltip top max-width="350px">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                      </template>
                      <span>En algunas ocasiones por la configuración de seguridad del asistente, los correos entran a la carpeta de SPAM. No te preocupes, aquí puedes enviar de nuevo cualquier boleto / acceso.</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <!--<v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="billingDialog = false">Cerrar</v-btn>
                </v-card-actions>-->
                <v-card-actions class="px-7 pb-4">
                  <!--<div class="flex-grow-1"></div>-->
                  <v-row justify="space-between">
                    <v-btn color="red darken-3" @click="closeSendTicket()" dark>Cancelar</v-btn>
                    <v-btn color="accent" @click="sendTicket( sendTicketItem)">Enviar</v-btn>
                  </v-row>
                </v-card-actions>
              </v-card>
              <!--<v-card v-if="modifyDialog">
                <v-card-title>
                  <span class="headline">Información del asistente</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.name"
                            :rules="nameRules"
                            label="Nombre(s)"
                            required
                            prepend-icon="fas fa-user"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.lastName"
                            :rules="lastNameRules"
                            label="Apellidos"
                            required
                            prepend-icon="fas fa-user"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.companyName"
                            :rules="companyRules"
                            label="Compañía"
                            required
                            prepend-icon="fas fa-industry"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.email"
                            :rules="emailRules"
                            label="E-mail"
                            required
                            prepend-icon="fas fa-envelope"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.productName"
                            :rules="ticketRules"
                            label="Tipo de boleto"
                            required
                            prepend-icon="fas fa-ticket-alt"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.date"
                            :rules="dateRules"
                            label="Fecha de compra"
                            required
                            prepend-icon="fas fa-calendar-day"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.buyer"
                            :rules="buyerRules"
                            label="Comprador"
                            required
                            prepend-icon="fas fa-user-tie"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close()">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="save()">Guardar</v-btn>
                </v-card-actions>
              </v-card>-->
            </v-dialog>
            <!--<v-dialog v-model="modifyDialog" max-width="900px">
              <v-card v-if="modifyDialog">
                <v-card-title>
                  <span class="headline">Editar información del asistente</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.name"
                            :rules="nameRules"
                            label="Nombre(s)"
                            required
                            prepend-icon="fas fa-user"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.lastName"
                            :rules="lastNameRules"
                            label="Apellidos"
                            required
                            prepend-icon="fas fa-user"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.companyName"
                            :rules="companyRules"
                            label="Compañía"
                            required
                            prepend-icon="fas fa-industry"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.email"
                            :rules="emailRules"
                            label="E-mail"
                            required
                            prepend-icon="fas fa-envelope"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.productName"
                            :rules="ticketRules"
                            label="Tipo de boleto"
                            required
                            prepend-icon="fas fa-ticket-alt"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.date"
                            :rules="dateRules"
                            label="Fecha de compra"
                            required
                            prepend-icon="fas fa-calendar-day"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.buyer"
                            :rules="buyerRules"
                            label="Comprador"
                            required
                            prepend-icon="fas fa-user-tie"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close()">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="save()">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>-->
            <v-dialog v-model="deleteDialog" max-width="500px">
              <v-card>
                <v-card-title>
                  <h2 class="subtitle-1">
                    ¿Seguro que desea eliminar al asistente "
                    <span
                      class="font-weight-bold"
                    >{{`${ editedItem.name } ${ editedItem.lastName }`}}</span>"?
                  </h2>
                </v-card-title>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close()">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="deleteAssistant()">Eliminar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { validations } from "@/helpers/validations.js";
import { mapMutations, mapState, mapActions } from "vuex";
import exportFromJSON from "export-from-json";
export default {
  data() {
    return {
      valid: true,
      search: "",
      modifyDialog: false,
      deleteDialog: false,
      sendTicketDialog: false,
      items: [],
      headers: [
        { align: "center", text: "Nombre", value: "name" },
        { align: "center", text: "Apellidos", value: "lastName" },
        { align: "center", text: "Empresa", value: "companyName" },
        { align: "center", text: "Email", value: "email" },
        { align: "center", text: "Boleto", value: "productName" },
        { align: "center", text: "Fecha", value: "date" },
        { align: "center", text: "Checked In", value: "checkedIn" },
        { align: "center", text: "Acciones", value: "sendTicket" },
        //{ align: "center", text: "Acciones", value: "action", sortable: false }
      ],
      editedIndex: -1,
      checkInData: {},
      ticketData: {},
      patronSpace: / /g,
      sendTicketItem: {
        orderId: "",
        attendeeId: "",
        name: "",
        lastName: "",
        companyName: "",
        email: "",
        productName: "",
        date: "",
        buyer: ""
      },
      editedItem: {
        name: "",
        lastName: "",
        companyName: "",
        email: "",
        productName: "",
        date: "",
        buyer: ""
      },
      defaultItem: {
        orderId: "",
        attendeeId: "",
        name: "",
        lastName: "",
        companyName: "",
        email: "",
        productName: "",
        date: "",
        buyer: ""
      },

      nameRules: validations.nameValidation(),
      lastNameRules: validations.surnamesValidation(),
      emailRules: validations.emailValidation(),
      companyRules: validations.nameValidation({
        required: true,
        minLength: 2,
        name: "nombre de la empresa"
      }),
      ticketRules: validations.nameValidation(),
      dateRules: validations.requiredValidation(),
      buyerRules: validations.nameValidation(),

      event: {
        name: "Congreso de restauración del patrimonio"
      }
    };
  },
  computed: {
    ...mapState("event", ["events"]),
    getSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size:1.8em";
        case "sm":
          return "font-size:1.8em";
        case "md":
          return "font-size:1.5em";
        case "lg":
          return "font-size:1.6em";
        case "xl":
          return "font-size:1.7em";
      }
    }
  },
  methods: {
    ...mapMutations("notifications", ["show"]),
    ...mapActions("order", ["checkInManual", "sendTicketManual"]),
    ...mapActions("event", ["fetchUserEvents"]),
    async downloadCsv(assistants, eventName) {
      let data = await this.getAssistants();
      const fileName = `Asistentes ${eventName}`;
      const exportType = "csv";
      data.sort(function(a, b) {
        if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
          return 1;
        }
        if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      exportFromJSON({ data, fileName, exportType });
    },
    getAssistants() {
      let items = [];
      this.event.assistants.forEach(async assistant => {
        assistant.extraFields.companyName = assistant.extraFields.companyName != ""?assistant.extraFields.companyName:"N/D"
        assistant.extraFields.tel = assistant.extraFields.tel != ""?assistant.extraFields.tel:"N/D"
        assistant.extraFields.checkedIn = assistant.checkedIn;
        assistant.extraFields.checkedIn = assistant.extraFields.checkedIn ? 'Si': 'No';
        //assistant.extraFields.updatedAt = assistant.updatedAt;
        //assistant.extraFields.orderId = assistant.orderId;
        await items.push(assistant.extraFields);
      });
      return items;
    },
    async checkIn(item) {
      try {
        this.checkInData = Object.assign({}, item);
        this.checkInData = {attendeeId: this.checkInData.attendeeId, checkedIn: this.checkInData.checkedIn, orderId: this.checkInData.orderId};
        let result = await this.checkInManual(this.checkInData);
      } catch (error) {
        console.log("No se encontró el asistente");
      }
      //console.log(result);
      //console.log(this.checkInData);
    },
    selectAttendeeTicket(item) {
      this.sendTicketDialog = true;
      this.sendTicketItem = Object.assign({}, item);
    },
    closeSendTicket() {
      this.sendTicketDialog = false;
      this.sendTicketItem = Object.assign({}, this.defaultItem);
    },
    async sendTicket(attendee) {
      this.closeSendTicket();
      this.checkInData = {attendeeId: this.checkInData.attendeeId, checkedIn: this.checkInData.checkedIn, orderId: this.checkInData.orderId};
      attendee.email = attendee.email.replace(this.patronSpace, "");
      this.ticketData = {orderId: attendee.orderId, attendeeId: attendee.attendeeId, email: attendee.email}
      let result = await this.sendTicketManual(this.ticketData);
      this.show({ text: "¡El boleto ha sido enviado! 😄" });
    },
    selectItem(item, flag) {
      this.editedIndex = this.event.assistants.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (flag) this.modifyDialog = true;
      else this.deleteDialog = true;
    },
    close() {
      this.modifyDialog = false;
      this.deleteDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    deleteAssistant() {
      this.event.assistants.splice(this.editedIndex, 1);
      this.close();
      this.show("Eliminación realizada con éxito!");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        Object.assign(this.event.assistants[this.editedIndex], this.editedItem);
        this.close();
        this.show("¡Modificación guardada con éxito!");
      }
    },
    formatData() {
      let newArray2 = [];
      let filteredEvent = this.events.filter(
        event => event.id == this.$route.params.id
      );
      let filteredOrders = filteredEvent[0].orders.filter(
        order => order.orderStatus != "IN_PROGRESS"
      );
      filteredOrders.map(order => {
        order.attendeeInformation.map(attendee => {
          let newAttendee = {
            attendeeId: attendee.id,
            name: attendee.name,
            lastName: attendee.lastName,
            companyName: attendee.companyName!=""?attendee.companyName:"N/D",
            email: attendee.email,
            productName: attendee.ticketName,
            date: new Date(order.createdAt).toLocaleDateString("es-MX"),
            checkedIn: attendee.checkedIn,
            extraFields: attendee.extraFields,
            buyer: `${order.paymentInformation.name} ${order.paymentInformation.lastName}`,
            orderId: order.id
          };
          newArray2.push(newAttendee);
        });
      });
      this.event.name = filteredEvent[0].name;
      this.event.assistants = newArray2;
      this.items = this.event.assistants;
      this.items = this.items.reverse();
    },
    async reloadTable() {
      await this.fetchUserEvents();
      this.formatData();
    }
  },
  mounted() {
    this.formatData();
  }
};
</script>
<style scoped>
.attended-color {
  background-color: rgba(83, 165, 72, 0.2);
}
</style>